import React from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { colors } from '../../style';

function Spinner() {
  return (
    <Box className="spinner-container" data-testid="spinner" sx={{ display: 'flex' }}>
      <CircularProgress
        sx={{
          color: colors.yubiGreen,
        }}
      />
    </Box>
  );
}

export default Spinner;
